import React from 'react';
import {connect} from "react-redux";
import LocalStorageService from "../../../localStorage-service";
import ApiService from "../../services/APIService";
import AppService from "../../services/AppService";


class AutoSave extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.setSaveInterval();
    }

    setSaveInterval = () => {
        this.refreshInterval = setInterval(() => {
            const {graph, schematicDocument} = this.props;
            const currentSchematicId = LocalStorageService.getSchematicId();
            const schematic_type_id = LocalStorageService.getSchematicTypeId();
            if (graph && schematicDocument && currentSchematicId) {
                graph.clearConnectionsHoverStyle();
                const json = AppService.getUpdatedSchematicJson(graph, schematicDocument);
                graph.saveHistorySnapshot();
                ApiService.saveSchematic({document_name: schematicDocument.document_name, json, schematic_type_id});
            }
        }, 60000);
    }

    componentWillUnmount() {
        clearInterval(this.refreshInterval);
    }

    render() {
        const {children} = this.props;
        return (
            <>
                {children}
            </>
        )
    }
}

const mapStateToProps = ({schematicReducers: {graph, schematicDocument}}) => {
    return {
        schematicDocument,
        graph: graph.value
    }
}

export default connect(mapStateToProps, null)(AutoSave);
